import React from 'react';
import { Calendar, Globe, Target, ShieldCheck, FileText } from 'lucide-react';
import { Badge } from './ui/Badge';
import { SectionWrapper } from './ui/SectionWrapper';
export function SocialProof() {
  const badges = [{
    text: 'Actualizado 2026',
    icon: <Calendar className="w-3 h-3" data-id="element-249" />
  }, {
    text: 'En español',
    icon: <Globe className="w-3 h-3" data-id="element-250" />
  }, {
    text: 'Enfoque 100% práctico',
    icon: <Target className="w-3 h-3" data-id="element-251" />
  }, {
    text: 'Sin humo',
    icon: <ShieldCheck className="w-3 h-3" data-id="element-252" />
  }, {
    text: 'Listo para PDF',
    icon: <FileText className="w-3 h-3" data-id="element-253" />
  }];
  return <SectionWrapper className="!py-8 border-b border-slate-100" data-id="element-254">
      <div className="flex flex-col items-center justify-center gap-4" data-id="element-255">
        <div className="flex flex-wrap justify-center gap-3" data-id="element-256">
          {badges.map((badge, index) => <Badge key={index} variant="default" icon={badge.icon} className="bg-slate-100 text-slate-600 border border-slate-200" data-id="element-257">
              {badge.text}
            </Badge>)}
        </div>
        <p className="text-xs text-slate-400 italic text-center max-w-2xl" data-id="element-258">
          No se prometen resultados específicos. Los resultados dependen del
          trabajo individual y las condiciones del mercado.
        </p>
      </div>
    </SectionWrapper>;
}